import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { StyledEngineProvider } from '@mui/material/styles'
import App from './App'

// I don't consider providing a disabled button to a Tooltip an error.
// console.error = (message) => {
  // if (message.includes('You are providing a disabled `button` child to the Tooltip component.')) {
  //   return; // Suppress specific warning
  // }
  // console.error(message); // Other warnings still show
  // console.info(message, "error"); // Other warnings still show

// };

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload()
  })
}

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
    <StyledEngineProvider injectFirst>
      <App />
    </StyledEngineProvider>
  // </StrictMode>,
)
